import React from 'react';
import { BackgroundColorsMap } from '@milanlaser/mlcomponents';

const HIDDEN = { visibility: 'hidden' };

// Mirrors the alignment classes S21PromotionalCountdown applies, so the reserved
// box matches the real banner.
const CONTENT_ALIGN = { left: 'mcl-items-start', center: 'mcl-items-center', right: 'mcl-items-end' };
const TEXT_ALIGN = { left: 'mcl-text-left', center: 'mcl-text-center', right: 'mcl-text-right' };

export function CountdownPlaceholder({ promoText, backgroundColor = 'Navy', textAlign = 'center' }) {
    return (
        <section
            className={`S21PromotionalCountdown ${BackgroundColorsMap[backgroundColor]} mcl-py-3`}
            aria-hidden="true"
        >
            <div className={`S21PromotionalCountdownContent ${CONTENT_ALIGN[textAlign]}`}>
                <div className={`S21PromotionalCountdownText ${TEXT_ALIGN[textAlign]}`} style={HIDDEN}>
                    {promoText}
                </div>
                <div className="S21CountdownTimer" style={HIDDEN}>
                    <div className="S21CountdownTimeContainer">
                        <span className="S21CountdownTimeNumber">00</span>
                        <span className="S21CountdownTimeLabel">Days</span>
                    </div>
                    <span className="S21CountdownSeparator">:</span>
                    <div className="S21CountdownTimeContainer">
                        <span className="S21CountdownTimeNumber">00</span>
                        <span className="S21CountdownTimeLabel">Hrs</span>
                    </div>
                    <span className="S21CountdownSeparator">:</span>
                    <div className="S21CountdownTimeContainer">
                        <span className="S21CountdownTimeNumber">00</span>
                        <span className="S21CountdownTimeLabel">Min</span>
                    </div>
                    <span className="S21CountdownSeparator">:</span>
                    <div className="S21CountdownTimeContainer">
                        <span className="S21CountdownTimeNumber">00</span>
                        <span className="S21CountdownTimeLabel">Sec</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
